import classNames from "classnames";
import { IconProps } from "../types";
import { asIcon } from "../utils/library";

const Profile = ({ className, height = "16px", width = "16px" }: IconProps) => {
    const classes = classNames("profileIcon", className);

    return (
        <svg
            className={classes}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            focusable="false"
        >
            <g
                xmlns="http://www.w3.org/2000/svg"
                id="Asset-7"
                transform="translate(6.000000, 0.000000)"
            >
                <path
                    d="M-3.2,22.9c-0.7,0-1.2-0.7-0.9-1.3C-3.4,19.4-1,15.3,6,15.3c7,0,9.4,4.1,10.2,6.3c0.2,0.7-0.2,1.3-0.9,1.3H-3.2z"
                    id="Path"
                />
                <ellipse id="Oval" cx="6" cy="7" rx="5.8" ry="5.9" />
            </g>
        </svg>
    );
};

const IconProfile = asIcon(Profile);
export default IconProfile;
